import { take, fork, cancel } from "redux-saga/effects";
import type { Task } from "redux-saga";

export function* takeLatestByKey<A>(
  actionCreator: { toString(): string },
  keySelector: (action: A) => string | number,
  saga: (action: A) => any
) {
  const tasks: Record<string | number, Task> = {};
  const type = actionCreator.toString();

  while (true) {
    const action: A = yield take(type);
    const key = keySelector(action);

    const previous = tasks[key];
    if (previous) {
      yield cancel(previous);
    }

    tasks[key] = yield fork(saga, action);
  }
}
